'use client';

import { createContext, useMemo, useState } from 'react';
import type { PropsWithChildren } from 'react';

import type { Nullable } from '@libs/core';
import type { ItemUI } from '@libs/common-node';

import AddedToCTCartDrawer from '@app/pdp/components/AddedToCTCartDrawer';

export type AddToCTCartDrawerProviderContextProps = {
    basketItems: ItemUI[];
    openAddedToCartDrawer: (products: ItemUI[]) => void;
};

export const AddToCTCartDrawerProviderContext =
    createContext<Nullable<AddToCTCartDrawerProviderContextProps>>(undefined);

export default function AddToCTCartDrawerProvider({
    children,
}: PropsWithChildren) {
    const [basketItems, setBasketItems] = useState<ItemUI[]>([]);

    const closeModalDrawer = () => {
        setBasketItems([]);
    };

    const openModalDrawer = (items: ItemUI[]) => {
        setBasketItems(items);
    };

    const value: AddToCTCartDrawerProviderContextProps = useMemo(
        () => ({
            basketItems,
            openAddedToCartDrawer: openModalDrawer,
        }),
        [basketItems]
    );

    return (
        <AddToCTCartDrawerProviderContext.Provider value={value}>
            {children}
            <AddedToCTCartDrawer
                basketItems={basketItems}
                onClose={closeModalDrawer}
            />
        </AddToCTCartDrawerProviderContext.Provider>
    );
}
